import type { LayoutHandleProps } from 'layouts/Layout/LayoutHandleProps';
import { orgDashboardViewPaymentRoute } from 'modules/orgDashboard/routing/orgDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from 'routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from 'routing/types/HorizonAppRouteComponentProps';

import { OrgDashboardViewPaymentPageLoadable } from './OrgDashboardViewPaymentPageLoadable';

export const handle = {
  fallbackUrlByLocaleToCurrent: true,
  darkBackground: true,
  showDesktopSearch: true,
} satisfies LayoutHandleProps;

export async function loader(
  _: HorizonAppRouteLoaderArgs<typeof orgDashboardViewPaymentRoute>,
) {
  await OrgDashboardViewPaymentPageLoadable.load();
}

export default function OrgDashboardViewPaymentHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  return <OrgDashboardViewPaymentPageLoadable />;
}
